export default "__VITE_ASSET__cia8EAjU__"